import { render, staticRenderFns } from "./CompanyInformationFormLocked.vue?vue&type=template&id=a9e96ab6&scoped=true&"
import script from "./CompanyInformationFormLocked.vue?vue&type=script&lang=js&"
export * from "./CompanyInformationFormLocked.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformationFormLocked.vue?vue&type=style&index=0&id=a9e96ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e96ab6",
  null
  
)

export default component.exports